var event;
var ids = "";
var source = "";

export function onPrintSaleInvCumBOS(data) {
  if (typeof app !== "undefined" && app !== null) {
    app.onPrintSaleInvCumBOS(data);
  }
}
export function shareFile(data, file) {
  if (typeof app !== "undefined" && app !== null) {
    app.shareFile(data, file);
  }
}
export function downloadFile(data, file, extension) {
  if (typeof app !== "undefined" && app !== null) {
    app.downloadFile(data, file, extension);
  }
}
export function sendToAndForDownload(data, file) {
  if (typeof app !== "undefined" && app !== null) {
    app.sendToAndForDownload(data, file);
  }
}
export function onPrintOrder(data) {
  if (typeof app !== "undefined" && app !== null) {
    app.onPrintOrder(data);
  }
}
export function OnPrintMakeToOrder(data) {
  if (typeof app !== "undefined" && app !== null) {
    app.onPrintMakeToOrder(data);
  }
}
export function printToken(data, tokenNo) {
  if (typeof app !== "undefined" && app !== null) {
    app.printToken(data, tokenNo);
  }
}

export function startScanner() {
  return app.startScanner();
}
export function qrCodeData(elementId, sourcepage) {
  ids = elementId;
  source = sourcepage;
  app.onQRCodeClicked();
}

export function setUserIdFromApp(userId) {
  if (typeof app !== "undefined" && app !== null) {
    console.log("USER ID=" + userId + "===============" + userId);
    app.setUserId(userId);
  }
}

export function pushSSEData(sseData) {
  if (typeof app !== "undefined" && app !== null) {
    console.log("SSE Data=" + sseData + "===============" + sseData);
    //app.receiveSSEData(sseData);
  }
}

export function disableFileChhoserfunction(sourceType) {
  console.log("showHide ID=" + sourceType);
  if (typeof app !== "undefined" && app !== null) {
    console.log("showHide ID=" + sourceType);
    app.disableFileChhoserfunction(sourceType);
  }
}
export function appUpdateForDevice(deviceId, refNo) {
  console.log("Sending T0 App:  deviceId=" + deviceId + " & Ref=" + refNo);
  if (typeof app !== "undefined" && app !== null) {
    app.appUpdateForDeviceMatched(deviceId, refNo);
  }
}
export function onMapClicked(data) {
  if (typeof app !== "undefined" && app !== null) {
    app.onMapClicked(data);
  }
}
export function textToSpeechAnd(data) {
  if (typeof app !== "undefined" && app !== null) {
    app.textToSpeechData(data);
  }
}

export function onPrintAggInvOrder(data) {
  if (typeof app !== "undefined" && app !== null) {
    app.onPrintAggInvOrder(data);
  }
}

export function onPrintKot(data) {
  if (typeof app !== "undefined" && app !== null) {
    app.onPrintKot(data);
  }
}

export function makePhoneCall(phoneNumber) {
  if (typeof app !== "undefined" && app !== null) {
    app.makePhoneCall(phoneNumber);
  }
}

///////////////////////////////////////////////////////////////////////////////////////////////////////////////
////////////////////////                    PULL DATA FUNCTION                       //////////////////////////
///////////////////////////////////////////////////////////////////////////////////////////////////////////////
window.getQR = function (data) {
  console.log("ABCDEFGH1222=" + data + "===============" + source);
  document.getElementById(ids).value = data;
  event = new Event(source);
  window.dispatchEvent(event);
  window.CloseEvent();
};
// window.sendFCMToken=function(token)
// {
//     console.log("Received Token=" + token);
//     //localStorage.setItem("FirebaseToken",token)
// }

window.retBackGPSCode = function (longLat) {
  console.log("retBackGPSCode==" + longLat);
  localStorage.setItem("lat", longLat.split("===")[0]);
  localStorage.setItem("long", longLat.split("===")[1]);
};
window.appUpdated = function (deviceId) {
  console.log("appUpdated==" + deviceId);
  localStorage.setItem("appUdatedInDevice", deviceId);
};
window.sendFCMToken = function (token) {
  console.log("Received Token=" + token);
  localStorage.setItem("FirebaseToken", token);
};
window.retDeviceId = function (id) {
  console.log("Received Device ID=" + id);
  localStorage.setItem("DeviceID", id);
};
window.pushedOrderData = function (title, body, data) {
  console.log("Received Order Data=" + title + "," + body + "," + data);
  var order = new CustomEvent("ReceivedPushedOrder", {
    detail: {
      title: title,
      body: body,
      data: data,
    },
  });

  window.dispatchEvent(order);
};

window.receiveAllData = function (data, pushType) {
  console.log(
    "Received Data Type=" +
    pushType +
    "  ==As==  " +
    data +
    "   ==== " +
    (pushType == "longlat") +
    "   ==== " +
    (pushType === "longlat")
  );
  if (pushType === "longlat" && data != null) {
    console.log(
      "Received Data Type Long : =" +
      data.split("===")[0] +
      "  ==lat==  " +
      data.split("===")[1]
    );
    localStorage.setItem("lat", data.split("===")[0]);
    localStorage.setItem("long", data.split("===")[1]);
    console.log(
      "Long Lat Set : lat " +
      localStorage.getItem("lat") +
      "  ==long==  " +
      localStorage.getItem("long")
    );
    var latlongFire = new CustomEvent("LongLatRec", {
      detail: { lat: data.split("===")[0], long: data.split("===")[1] },
    });
    window.dispatchEvent(latlongFire);
  }

  if (pushType == "FirebaseToken") {
    localStorage.setItem("FirebaseToken", data);
  }
  if (pushType == "DeviceID") {
    localStorage.setItem("DeviceID", data);
  }
  if (pushType == "AppUpdated") {
    localStorage.setItem("appUdatedInDevice", data);
  }

  if (
    localStorage.getItem("DeviceID") != null &&
    localStorage.getItem("FirebaseToken") != null
  ) {
    event = new Event("ReceivedDeviceInfo");
    window.dispatchEvent(event);
  }
  if (pushType == "Notification") {
    event = new Event("ReceivedNotification");
    window.dispatchEvent(event);
  }
};
///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
////////////////////////////////                Code To block multiple Tabs of the same website                  //////////////////////
///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
localStorage.openpages = Date.now();
var onLocalStorageEvent = function (e) {
  if (e.key == "openpages") {
    localStorage.page_available = Date.now();
  }
  if (e.key == "page_available") {
    event = new Event("tabOpened");
    window.dispatchEvent(event);
    window.CloseEvent();
  }
};
window.addEventListener("storage", onLocalStorageEvent, false);

///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
////////////////////////////////                                    Added For SSE                                //////////////////////
///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
export function SSELoader() {
  console.log(
    "Loading on Device ID=" + document.getElementById("deviceId").innerHTML
  );
  if (
    location.href.includes("okta-login") ||
    location.href.includes("http://localhost:8030") ||
    document.getElementById("deviceId").innerHTML == null
  )
    return;
  var source = new EventSource(
    "https://integration.mobitrix.net/enableSSEForTheDigitalDevice/" +
    document.getElementById("deviceId").innerHTML,
    {
      mode: "no-cors",
      header: {
        "Access-Control-Allow-Origin": "*",
      },
    }
  );
  source.addEventListener(
    "message",
    function (e) {
      console.log(e.data);
      getSSEResponse(e.data);
    },
    false
  );
}
// setTimeout(SSELoader, 30000);
// setInterval(SSELoader, 600000);

export function getSSEResponse(data) {
  // var selectionFired = new CustomEvent("SSEMessage", {
  //   detail: { resp: data },
  // });
  //SSELoader();
  //window.dispatchEvent(selectionFired);
}

export function StopMessageAndBeep() {
  if (typeof app !== "undefined" && app !== null) {
    console.log("StopMessageAndBeep");
    app.onNewOrderDialogCloseAnd();
  }
}
export function PushUserIdAndLocToAndroidApp(userId, loc) {
  if (typeof app !== "undefined" && app !== null) {
    console.log("getUserIdAndLoc Pushed From Web: " + userId + "====" + loc);
    app.getUserIdAndLoc(userId, loc);
  }
}
export function StopPlayingMusic() {
  if (typeof app !== "undefined" && app !== null) {
    console.log("Stop Playing Music Called");
    app.StopPlayingMusic();
  }
}

export function logOutApp() {
  if (typeof app !== "undefined" && app !== null) {
    app.logOutClicked();
  }
}
module.exports = {
  StopPlayingMusic,
  PushUserIdAndLocToAndroidApp,
  StopMessageAndBeep,
  textToSpeechAnd,
  onPrintSaleInvCumBOS,
  shareFile,
  downloadFile,
  sendToAndForDownload,
  onPrintAggInvOrder,
  onPrintKot,
  makePhoneCall,
  onPrintOrder,
  OnPrintMakeToOrder,
  printToken,
  startScanner,
  qrCodeData,
  setUserIdFromApp,
  pushSSEData,
  disableFileChhoserfunction,
  appUpdateForDevice,
  onMapClicked,
  logOutApp,
};

const lazyRetry = function (componentImport) {
  return new Promise((resolve, reject) => {
    // check if the window has already been refreshed
    const hasRefreshed = JSON.parse(
      window.sessionStorage.getItem("retry-lazy-refreshed") || "false"
    );
    // try to import the component
    componentImport()
      .then((component) => {
        window.sessionStorage.setItem("retry-lazy-refreshed", "false"); // success so reset the refresh
        resolve(component);
      })
      .catch((error) => {
        if (!hasRefreshed) {
          // not been refreshed yet
          window.sessionStorage.setItem("retry-lazy-refreshed", "true"); // we are now going to refresh
          return window.location.reload(); // refresh the page
        }
        reject(error); // Default error behaviour as already tried refresh
      });
  });
};
